import { render } from "./SquadForm.vue?vue&type=template&id=2b7ea6ce"
import script from "./SquadForm.vue?vue&type=script&lang=js"
export * from "./SquadForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__